import { Box } from "@mui/material";

import { METRO_INK } from "./metro-theme";

export type MetroPlaqueProps = {
    number: number;
    title: string;
    status: string;
    color: string;
    top: number;
    /** Plaques sit at the end of the row away from the turn that leads into it. */
    side: 'left' | 'right';
};

/** The name board of one line: the lesson group, its number and how far the user got with it. */
export function MetroPlaque({ number, title, status, color, top, side }: MetroPlaqueProps) {
    return (
        <Box component="section" aria-label={ `${ title }: ${ status }` } sx={ {
            position: 'absolute', top, [side]: 72,
            display: 'inline-flex', alignItems: 'center', gap: 1,
            bgcolor: '#FFFFFF', border: `2px solid ${ METRO_INK }`, borderRadius: '10px', px: 1.25, py: 0.625,
            boxShadow: `3px 3px 0 ${ METRO_INK }`,
        } }>
            <Box component="span" aria-hidden="true" sx={ {
                width: 22, height: 22, borderRadius: '11px', bgcolor: color, border: `2px solid ${ METRO_INK }`, boxSizing: 'border-box',
                color: '#FFFFFF', fontSize: 11, fontWeight: 800, display: 'flex', alignItems: 'center', justifyContent: 'center',
            } }>
                { number }
            </Box>
            <Box component="h2" sx={ { m: 0, fontSize: 13, fontWeight: 800 } }>{ title }</Box>
            <Box component="span" sx={ { fontSize: 12, color: '#4F5B67' } }>{ status }</Box>
        </Box>
    );
}
